import { createCamelResponseTransformer } from 'axios-case-converter/es/middleware';
export var caseOptions = {// Use default config
};
export var convertToCamelCase = createCamelResponseTransformer(caseOptions);